import { render, staticRenderFns } from "./package-weigh.vue?vue&type=template&id=76a1ef52&scoped=true&"
import script from "./package-weigh.vue?vue&type=script&lang=js&"
export * from "./package-weigh.vue?vue&type=script&lang=js&"
import style0 from "./package-weigh.vue?vue&type=style&index=0&id=76a1ef52&lang=less&scoped=true&"
import style1 from "./package-weigh.vue?vue&type=style&index=1&lang=less&"
import style2 from "./package-weigh.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a1ef52",
  null
  
)

export default component.exports